import { render, staticRenderFns } from "./moreGame.vue?vue&type=template&id=020e2722&scoped=true"
import script from "./moreGame.vue?vue&type=script&lang=js"
export * from "./moreGame.vue?vue&type=script&lang=js"
import style0 from "./moreGame.vue?vue&type=style&index=0&id=020e2722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020e2722",
  null
  
)

export default component.exports